exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wapimportant_pagetop{position:relative;width:100%;max-height:98px;overflow: hidden;}\r\n.wapimportant_pagetop img{width:100%;vertical-align:middle;margin:0;padding:0;border:none}\r\n.wapimportant_pagetop .close{margin:0;padding:0;display:block;width:10%;height:100%;position:absolute;z-index:999;top:0;right:0;border:0}\r\n.wapimportant_pagebuttom_fix{position:fixed;bottom:0;z-index:9999;max-height:98px;overflow: hidden;}\r\n.wapimportant_pagebuttom_fix img{width:100%;vertical-align:middle;margin:0;padding:0;border:none}\r\n.wapimportant_pagebuttom_fix .close{margin:0;padding:0;display:block;width:8%;height:100%;position:absolute;z-index:999;top:0;right:0;border:0}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./dev/modules/ad/ad.css
// module id = 3
// module chunks = 0 5 6 7 8 9 10 12 14 15 16 17 19